/**
 * Hooks del perfil de empresa singleton (mejora "Perfil empresa").
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchWithAuth } from "@/lib/api/client";
import { showToast } from "@/lib/toast";
import type { components } from "@/lib/api/generated";

export type EmpresaProfileRead = components["schemas"]["EmpresaProfileRead"];
export type EmpresaProfileUpdate = components["schemas"]["EmpresaProfileUpdate"];

const KEY = ["empresa-profile"] as const;

export function useEmpresaProfile() {
  return useQuery<EmpresaProfileRead, Error>({
    queryKey: KEY,
    queryFn: () => fetchWithAuth("/api/v1/empresa-profile"),
    staleTime: 5 * 60_000,
  });
}

export function useUpdateEmpresaProfile() {
  const qc = useQueryClient();
  return useMutation<EmpresaProfileRead, Error, EmpresaProfileUpdate>({
    mutationFn: (payload) =>
      fetchWithAuth("/api/v1/empresa-profile", {
        method: "PUT",
        body: JSON.stringify(payload),
      }),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data);
      showToast.success("Perfil de empresa guardado");
    },
    onError: (e) => showToast.error(e.message || "Error al guardar el perfil"),
  });
}
